import { render, staticRenderFns } from "./BulletinCenter.vue?vue&type=template&id=682691ed&scoped=true&"
import script from "./BulletinCenter.vue?vue&type=script&lang=js&"
export * from "./BulletinCenter.vue?vue&type=script&lang=js&"
import style0 from "./BulletinCenter.vue?vue&type=style&index=0&id=682691ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682691ed",
  null
  
)

export default component.exports